import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import useLoan from '../../../../../hooks/useLoan';
import routes from '../../../../../../../resources/routes.json';

import { getCounterOffer, FIND_COUNTER_OFFER_SUCCESS } from '../../../../../store/actions/application-actions';
import { findCurrentLoan } from '../../../../../store/actions/customer-actions';
import { goToLoanRoute } from '../../../../../navigation/application-routes';

import Loading from 'components/features/loading/loading';
import { Button, Container, Typography } from 'lib-ui-react';
import useEvents from '../../../../../hooks/useEvents';
import { loanHasApplicationTestTag } from '../../../../../utils/helper/loan-helper';

function CounterOfferLoanAmount() {
  const { dispatchCompleteEvent } = useEvents('application-customer-portal-web-page-contract-recurring-counter-offer', 'recurring-counter-offer')
  const { dispatchCompleteEvent: dispatchMultiOfferEvent } = useEvents('application-customer-portal-web-page-contract-recurring-multi-offer', 'recurring-multi-offer')
  const dispatch = useDispatch();
  const { device, loan } = useLoan();

  const [loading, setLoading] = useState(false);

  function handleLoanAmountLow() {
    dispatchCompleteEvent('loan-amount-low')

    if (loanHasApplicationTestTag('2024-09-All-recurringMultiOffer', 'multi-and-counter-offer', loan)) {
      sessionStorage.setItem('startProcessCounterOfferRecurrent', false);
      sessionStorage.setItem('showMultiOffer', true)
      dispatchMultiOfferEvent('click-see-multi-offer-by-loan-amount-low')
      goToLoanRoute(loan, routes.LOAN_COUNTER_OFFER_PROCESS, routes.LOAN_APPLICATION_CONTRACT);
      return
    }

    setLoading(true);
    dispatch(getCounterOffer(device, 'loan-amount', 'low', loan?.id)).then((response) => {
      if (response.type === FIND_COUNTER_OFFER_SUCCESS) {
        dispatch(findCurrentLoan(device)).then(({ payload: loan }) => {
          setLoading(false);
          sessionStorage.setItem('startProcessCounterOfferRecurrent', false);
          sessionStorage.setItem('betterConditionsFinded', response.payload ? 'true' : 'false');

          goToLoanRoute(loan, routes.LOAN_COUNTER_OFFER_PROCESS, routes.LOAN_APPLICATION_CONTRACT);
        });
      }
    });
  }

  function handleLoanAmountHigh() {
    dispatchCompleteEvent('loan-amount-high')
    setLoading(true);
    dispatch(getCounterOffer(device, 'loan-amount', 'high', loan?.id)).then((response) => {
      if (response.type === FIND_COUNTER_OFFER_SUCCESS) {
        dispatch(findCurrentLoan(device)).then(({ payload: loan }) => {
          setLoading(false);
          sessionStorage.setItem('startProcessCounterOfferRecurrent', false);
          sessionStorage.setItem('betterConditionsFinded', response.payload ? 'true' : 'false');

          goToLoanRoute(loan, routes.LOAN_COUNTER_OFFER_PROCESS, routes.LOAN_APPLICATION_CONTRACT);
        });
      }
    });
  }

  if (loading) {
    return (
      <>
        <Loading title="Aguarde um momento, por favor..." />
      </>
    );
  }

  return (
    <Container spacing={24} padding={16} height="100vh">
      <Container spacing={8}>
        <Typography type="title" size="medium" fontWeight={400} lineHeight="28px" color="#2A2B35">
          Entendi! O que você achou <b>do valor do empréstimo?</b>
        </Typography>

        <Typography size="small" fontWeight={400} lineHeight="20px" color="#757575">
          Selecione uma opção abaixo.
        </Typography>
      </Container>

      <Container align="center" justify="center" spacing={8}>
        <Button
          id="low"
          outlined
          color="#757575"
          borderColor="#E0E0E0"
          margin="0"
          style={{ maxWidth: 'none' }}
          onClick={handleLoanAmountLow}
        >
          Baixo (não me ajuda no momento)
        </Button>
        <Button
          id="high"
          outlined
          color="#757575"
          borderColor="#E0E0E0"
          margin="0"
          style={{ maxWidth: 'none' }}
          onClick={handleLoanAmountHigh}
        >
          Alto (acima das expectativas)
        </Button>
      </Container>
    </Container>
  );
}

export default CounterOfferLoanAmount;
